module.exports = __webpack_public_path__ + "static/assets/029f26497705ef61ab779e0750cc7f4f.png";